const desktopCollapse = document.querySelector("[data-js='desktop-collapse']");

if (desktopCollapse) {
  const desktopCollapseBtn = document.querySelector("#desktop-collapse-btn");

  desktopCollapseBtn.addEventListener("click", function () {
    desktopCollapse.classList.toggle("open");
    if (desktopCollapseBtn.innerHTML === showAllFeatures) {
      desktopCollapseBtn.innerHTML = showLessFeatures;
    } else {
      desktopCollapseBtn.innerHTML = showAllFeatures;
    }
  });
}
